(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.cart-page');
    if (!root) return;

    var form = document.getElementById('CartPageForm');
    var updateBtn = document.getElementById('CartUpdateSubmit');

    root.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      var dec = wrap.querySelector('[data-qty-decrease]');
      var inc = wrap.querySelector('[data-qty-increase]');
      if (!input || !dec || !inc || !form || !updateBtn) return;

      function submitUpdate() {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(updateBtn);
        } else {
          updateBtn.click();
        }
      }

      dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, v - 1);
        submitUpdate();
      });
      inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        input.value = v + 1;
        submitUpdate();
      });
    });

    var applyBtn = root.querySelector('[data-apply-discount]');
    var discountInput = document.getElementById('CartDiscountInput');
    if (applyBtn && discountInput) {
      applyBtn.addEventListener('click', function () {
        var code = (discountInput.value || '').trim();
        if (!code) return;
        var path = '/discount/' + encodeURIComponent(code);
        var redirect = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = path + '?redirect=' + redirect;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["construction-management"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-cm-section]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var mainImage = section.querySelector('[data-cm-main-image]');
      var items = Array.prototype.slice.call(section.querySelectorAll('[data-cm-item]'));
      if (!mainImage || !items.length) return;

      function setActive(item) {
        var url = item.getAttribute('data-cm-image-url');
        if (!url) return;

        items.forEach(function (el) {
          el.classList.remove('is-active');
        });
        item.classList.add('is-active');

        if (mainImage.getAttribute('src') !== url) {
          mainImage.style.opacity = '0.92';
          mainImage.setAttribute('src', url);
          var alt = item.getAttribute('data-cm-image-alt') || '';
          mainImage.setAttribute('alt', alt);
          requestAnimationFrame(function () {
            mainImage.style.opacity = '1';
          });
        }
      }

      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          setActive(item);
        });
        item.addEventListener('focusin', function () {
          setActive(item);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-shell"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-show-password]').forEach(function (btn) {
      var root = btn.closest('.customers-auth');
      var id = btn.getAttribute('aria-controls');
      if (!id || !root) return;
      var input = document.getElementById(id);
      if (!input) return;
      var showLabel = root.getAttribute('data-pw-show') || btn.textContent.trim();
      var hideLabel = root.getAttribute('data-pw-hide') || 'Hide';

      btn.addEventListener('click', function () {
        var isHidden = input.type === 'password';
        input.type = isHidden ? 'text' : 'password';
        btn.setAttribute('aria-pressed', isHidden ? 'true' : 'false');
        btn.textContent = isHidden ? hideLabel : showLabel;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-capture"]) return;
  try {
    
  (function () {
    var root = document.getElementById('EmailCaptureRoot')
    if (!root) return
    var dialog = document.getElementById('EmailCaptureDialog')
    if (!dialog || typeof dialog.showModal !== 'function') return

    var delaySec = parseInt(root.dataset.delay || '7', 10)
    var key = root.dataset.storageKey || 'saltMarinEmailPopup'
    var klaviyoId = root.dataset.klaviyoId

    try {
      if (sessionStorage.getItem(key) === '1') return
    } catch (e) {}

    function openPopup() {
      try {
        if (sessionStorage.getItem(key) === '1') return
      } catch (e) {}
      if (!dialog.open) dialog.showModal()
    }

    function markSeen() {
      try {
        sessionStorage.setItem(key, '1')
      } catch (e) {}
    }

    var closeBtn = dialog.querySelector('[data-close-email-popup]')
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close()
        markSeen()
      })
    }

    dialog.addEventListener('cancel', function () {
      markSeen()
    })

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) {
        dialog.close()
        markSeen()
      }
    })

    if (klaviyoId) {
      var existing = document.querySelector('script[data-klaviyo-onsite]')
      if (!existing) {
        var s = document.createElement('script')
        s.async = true
        s.dataset.klaviyoOnsite = 'true'
        s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(klaviyoId)
        document.head.appendChild(s)
      }
    }

    window.setTimeout(openPopup, Math.max(0, delaySec) * 1000)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const page = document.currentScript?.closest('.product-page') || document.querySelector('.product-page');
    if (!page) return;

    const featured = page.querySelector('.product-page__featured-image');
    const featuredWrap = page.querySelector('.product-page__featured');
    const featuredInner = page.querySelector('.product-page__featured-inner');
    const zoomLens = page.querySelector('.product-page__zoom-lens');

    page.querySelectorAll('.product-page__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        page.querySelectorAll('.product-page__thumb').forEach((el) => el.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (featured) {
          featured.src = thumb.dataset.mediaUrl || featured.src;
          featured.alt = thumb.dataset.mediaAlt || featured.alt;
        }
      });
    });

    if (featuredWrap && featuredInner && featured && zoomLens) {
      const ZOOM = 2.25;
      const LENS_PX = 120;
      const mmReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mmHover = window.matchMedia('(hover: hover)');
      const mmWide = window.matchMedia('(min-width: 750px)');

      function magnifyEnabled() {
        return mmWide.matches && mmHover.matches && !mmReduce.matches;
      }

      function hideLens() {
        zoomLens.style.opacity = '0';
        zoomLens.style.visibility = 'hidden';
      }

      function showLens() {
        zoomLens.style.opacity = '1';
        zoomLens.style.visibility = 'visible';
      }

      function onLensMove(e) {
        if (!magnifyEnabled()) {
          hideLens();
          return;
        }
        const fr = featuredWrap.getBoundingClientRect();
        const imgR = featured.getBoundingClientRect();
        const x = e.clientX - imgR.left;
        const y = e.clientY - imgR.top;
        if (x < 0 || y < 0 || x > imgR.width || y > imgR.height || !featured.naturalWidth) {
          hideLens();
          return;
        }
        const srcUrl = featured.currentSrc || featured.src;
        zoomLens.style.backgroundImage = 'url(' + JSON.stringify(srcUrl) + ')';
        const bgW = imgR.width * ZOOM;
        const bgH = imgR.height * ZOOM;
        zoomLens.style.backgroundSize = bgW + 'px ' + bgH + 'px';
        const half = LENS_PX / 2;
        zoomLens.style.backgroundPosition =
          half - x * ZOOM + 'px ' + (half - y * ZOOM) + 'px';
        let lx = e.clientX - fr.left - half;
        let ly = e.clientY - fr.top - half;
        lx = Math.max(0, Math.min(lx, fr.width - LENS_PX));
        ly = Math.max(0, Math.min(ly, fr.height - LENS_PX));
        zoomLens.style.width = LENS_PX + 'px';
        zoomLens.style.height = LENS_PX + 'px';
        zoomLens.style.left = lx + 'px';
        zoomLens.style.top = ly + 'px';
        showLens();
      }

      function onLensLeave() {
        hideLens();
      }

      let lensListenersAttached = false;

      function syncMagnifyListeners() {
        if (magnifyEnabled()) {
          if (!lensListenersAttached) {
            featuredWrap.setAttribute('data-product-magnify', '');
            featuredInner.addEventListener('pointermove', onLensMove);
            featuredInner.addEventListener('pointerleave', onLensLeave);
            lensListenersAttached = true;
          }
        } else {
          if (lensListenersAttached) {
            featuredInner.removeEventListener('pointermove', onLensMove);
            featuredInner.removeEventListener('pointerleave', onLensLeave);
            featuredWrap.removeAttribute('data-product-magnify');
            lensListenersAttached = false;
          }
          hideLens();
        }
      }

      syncMagnifyListeners();
      mmWide.addEventListener('change', syncMagnifyListeners);
      mmHover.addEventListener('change', syncMagnifyListeners);
      mmReduce.addEventListener('change', syncMagnifyListeners);
    }

    const tabsRoot = page.querySelector('[data-product-tabs]');

    function activateProductTab(key, scrollToTabs) {
      if (!tabsRoot || !key) return false;
      const tabButtons = tabsRoot.querySelectorAll('.product-page__tab-btn');
      const tabPanels = tabsRoot.querySelectorAll('.product-page__tab-panel');
      let exists = false;
      tabButtons.forEach((btn) => {
        if (btn.dataset.tab === key) exists = true;
      });
      if (!exists) return false;
      tabButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.tab === key);
      });
      tabPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.panel === key);
      });
      if (scrollToTabs) {
        tabsRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return true;
    }

    if (tabsRoot) {
      tabsRoot.querySelectorAll('.product-page__tab-btn').forEach((btn) => {
        btn.addEventListener('click', () => activateProductTab(btn.dataset.tab, false));
      });
    }

    page.querySelectorAll('[data-buybox-scroll-tab]').forEach((trigger) => {
      trigger.addEventListener('click', () => activateProductTab(trigger.dataset.buyboxScrollTab, true));
    });

    const qtyInput = page.querySelector('.buybox__qty-input');
    page.querySelector('[data-buybox-qty-dec]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      const min = Number(qtyInput.getAttribute('min')) || 1;
      let v = Number(qtyInput.value) || 1;
      qtyInput.value = String(Math.max(min, v - 1));
    });
    page.querySelector('[data-buybox-qty-inc]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      let v = Number(qtyInput.value) || 1;
      qtyInput.value = String(v + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-registration"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'saltmarine_wholesale_v1';
    var form = document.getElementById('WholesaleApplicationForm');
    if (!form) return;
    form.setAttribute('novalidate', 'novalidate');

    var root = form.closest('.wholesale-app');
    var bodyField = document.getElementById('WholesaleContactBody');
    var subjectField = document.getElementById('WholesaleContactSubject');
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-wh-step]'));
    var progressLabel = form.querySelector('.wholesale-app__progress-label');
    var progressWrap = form.querySelector('[data-wh-progress-wrap]');
    var announce = form.querySelector('[data-wh-step-announce]');
    var current = 1;

    function readState() {
      var state = {};
      form.querySelectorAll('[data-wh-field]').forEach(function (el) {
        var key = el.getAttribute('data-wh-field');
        if (!key) return;
        if (el.type === 'checkbox') {
          state[key] = el.checked;
        } else if (el.type === 'radio') {
          if (el.checked) state[key] = el.value;
        } else {
          state[key] = el.value;
        }
      });
      return state;
    }

    function writeState(data) {
      Object.keys(data).forEach(function (key) {
        var els = form.querySelectorAll('[data-wh-field="' + key + '"]');
        if (!els.length) return;
        var val = data[key];
        els.forEach(function (el) {
          if (el.type === 'checkbox') {
            el.checked = !!val;
          } else if (el.type === 'radio') {
            el.checked = el.value === val;
          } else {
            el.value = val != null ? String(val) : '';
          }
        });
      });
    }

    function saveDraft() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(readState()));
      } catch (e) {}
    }

    function loadDraft() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var data = JSON.parse(raw);
        if (data && typeof data === 'object') writeState(data);
      } catch (e) {}
    }

    function showStep(n) {
      current = n;
      steps.forEach(function (panel) {
        var sn = parseInt(panel.getAttribute('data-wh-step'), 10);
        var on = sn === n;
        panel.hidden = !on;
        panel.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      if (progressLabel) {
        var fmt = progressLabel.getAttribute('data-wh-progress-fmt');
        var total = 3;
        if (fmt) {
          progressLabel.textContent = fmt.replace(/__C__/g, String(n)).replace(/__T__/g, String(total));
        }
      }
      if (progressWrap) {
        progressWrap.setAttribute('aria-valuenow', String(n));
      }
      for (var b = 1; b <= 3; b++) {
        var bar = form.querySelector('[data-wh-bar="' + b + '"]');
        if (!bar) continue;
        bar.classList.remove('is-done', 'is-current', 'is-upcoming');
        if (b < n) bar.classList.add('is-done');
        else if (b === n) bar.classList.add('is-current');
        else bar.classList.add('is-upcoming');
      }
      if (announce && root) {
        var ak = root.getAttribute('data-wh-announce-step' + n);
        if (ak) announce.textContent = ak;
      }
      if (n === 3) fillReview();
      var scrollY = form.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({ top: Math.max(0, scrollY), behavior: 'smooth' });
    }

    function fieldInStep(stepNum, el) {
      var panel = el.closest('[data-wh-step]');
      return panel && parseInt(panel.getAttribute('data-wh-step'), 10) === stepNum;
    }

    function validateStep(n) {
      var ok = true;
      var firstInvalid = null;

      function noteInvalid(el) {
        ok = false;
        if (!firstInvalid) firstInvalid = el;
      }

      var fields = form.querySelectorAll('[data-wh-field]');
      fields.forEach(function (el) {
        if (!fieldInStep(n, el)) return;
        if (el.type === 'radio') {
          if (!el.hasAttribute('required')) return;
          var name = el.name;
          var group = form.querySelectorAll('input[type="radio"][name="' + name + '"]');
          var any = Array.prototype.some.call(group, function (r) {
            return r.checked;
          });
          if (!any) noteInvalid(group[0] || el);
          return;
        }
        if (el.hasAttribute('required') && !el.checkValidity()) {
          noteInvalid(el);
        }
      });

      if (firstInvalid) {
        try {
          firstInvalid.focus({ preventScroll: true });
        } catch (err) {
          firstInvalid.focus();
        }
        firstInvalid.reportValidity();
      }
      return ok;
    }

    function labelForAccountType(v) {
      if (!root || !v) return v || '—';
      var lab = root.getAttribute('data-wh-label-' + v);
      return lab || v || '—';
    }

    function fillReview() {
      var data = readState();
      form.querySelectorAll('[data-wh-review-field]').forEach(function (el) {
        var k = el.getAttribute('data-wh-review-field');
        var v = data[k];
        if (k === 'accountType') v = labelForAccountType(v);
        el.textContent = v && String(v).trim() ? v : '—';
      });
    }

    function buildBody(data) {
      var lines = [
        '=== Wholesale dealer application (full) ===',
        '',
        '— Step 1: Business —',
        'Company: ' + (data.company || ''),
        'Business type: ' + (data.businessType || ''),
        'Contact name: ' + (data.contactName || ''),
        'Job title: ' + (data.jobTitle || ''),
        'Email: ' + (data.email || ''),
        'Phone: ' + (data.phone || ''),
        'Business address: ' + (data.businessAddress || ''),
        '',
        '— Step 2: Tax & operations —',
        'EIN: ' + (data.ein || ''),
        'FL resale certificate: ' + (data.resaleCertificate || ''),
        'Account type: ' + (data.accountType || ''),
        'Estimated monthly volume: ' + (data.monthlyVolume || ''),
        'Engine brands serviced: ' + (data.engineBrands || ''),
        'Additional notes: ' + (data.additionalNotes || ''),
        '',
        '— Agreements —',
        'Wholesale terms accepted: ' + (data.agreeWholesaleTerms ? 'yes' : 'no'),
        'Accurate information: ' + (data.agreeAccurate ? 'yes' : 'no'),
        'Privacy / terms acknowledgment: ' + (data.agreePrivacy ? 'yes' : 'no'),
        '',
        '— JSON (machine-readable) —',
        JSON.stringify(data, null, 2),
      ];
      return lines.join('\n');
    }

    form.addEventListener('input', saveDraft);
    form.addEventListener('change', saveDraft);

    form.querySelectorAll('[data-wh-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!validateStep(current)) return;
        saveDraft();
        if (current < 3) showStep(current + 1);
      });
    });

    form.querySelectorAll('[data-wh-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        saveDraft();
        if (current > 1) showStep(current - 1);
      });
    });

    form.addEventListener('submit', function (e) {
      if (!validateStep(1)) {
        e.preventDefault();
        showStep(1);
        return;
      }
      if (!validateStep(2)) {
        e.preventDefault();
        showStep(2);
        return;
      }
      if (!validateStep(3)) {
        e.preventDefault();
        showStep(3);
        return;
      }
      var data = readState();
      if (bodyField) bodyField.value = buildBody(data);
      if (subjectField && data.company) {
        var base = subjectField.value || 'Wholesale application';
        subjectField.value = base + ' — ' + data.company;
      }
      try {
        localStorage.setItem(STORAGE_KEY + '_last_submit', JSON.stringify(data));
      } catch (err) {}
    });

    loadDraft();
    showStep(1);
  })();

  } catch(e) { console.error(e); }
})();
})();
